export const blockIconsHardwareComputer = (
	<span className='material-symbols-outlined'>computer</span>
);
